import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState(() => {
        try {
            const savedCart = localStorage.getItem('cplus_cart');
            return savedCart ? JSON.parse(savedCart) : [];
        } catch (e) {
            console.error('Failed to parse cart', e);
            return [];
        }
    });

    // Save cart to local storage when it changes
    useEffect(() => {
        localStorage.setItem('cplus_cart', JSON.stringify(cartItems));
    }, [cartItems]);

    const addToCart = (item) => {
        // Prevent duplicate domains
        if (item.type === 'domain' && cartItems.find(i => i.id === item.id)) {
            return false;
        }
        setCartItems(prev => [...prev, item]);
        return true;
    };

    const removeFromCart = (id) => {
        setCartItems(prev => prev.filter(item => item.id !== id));
    };

    const clearCart = () => {
        setCartItems([]);
    };

    const cartTotal = cartItems.reduce((total, item) => total + (item.price || 0), 0);

    return (
        <CartContext.Provider value={{
            cartItems,
            addToCart,
            removeFromCart,
            clearCart,
            cartTotal,
            itemCount: cartItems.length
        }}>
            {children}
        </CartContext.Provider>
    );
};
